<template>
  <div slider-timer>
    <ul>
      <li v-for="(item, index) in list" :key="item.sq" @click="change(index)" :class="{on: index === idx}">
        <div class="bar">
          <div class="fill over"></div>
          <div class="fill" v-if="index === idx" :style="{ width: percent }"></div>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'SliderTimer',
  props: ['list', 'target','scope'],
  data() {
    return {
      slider: null,
      idx: 0,
      duration: 9000,
      intervalId: -1,
      progress: 0,
    };
  },
  computed: {
    percent() {
      return this.intervalId > -1 ? `${this.progress / this.duration * 100}%` : '100%';
    },
  },
  methods: {
    tick() {
      this.progress += 20;
      if (this.progress >= this.duration) {
        this.slider.next();
        this.progress = 0;
      }
    },
    change(idx) {
      this.slider.go(idx + 1);
      this.sliderMove();
    },
    changed(idx) {
      this.progress = 0;
      this.idx = idx;
    },
    sliderMove() {
      this.progress = 0;
      // clearInterval(this.intervalId);
      // this.intervalId = -1;
    },
  },
  mounted() {
    this.slider = this.scope[this.target];
    if (this.slider && this.slider.setTimer) this.slider.setTimer(this);
    else throw new Error('Slider 가 없거나 정상적이지 않음');
    this.intervalId = setInterval(this.tick, 20);
  },
  beforeDestroy() {
    if (this.intervalId > -1) clearInterval(this.intervalId);
  }
};
</script>

<style lang="less">
@import "~@/less/proj";
[slider-timer] { .p(0,14); .-box;
  ul { .ib-list; }
  li { .p(8,6,10); .rel; .w(25%); .-box; .pointer;
    .bar { .h(2); .bgc(rgba(224,224,224,0.4)); .rel;
      .fill { .h(2); .bgc(#fff); .w(0); }
      .over { .abs; transition: width 0.4s; }
    }
  }
}

@media (min-width: @screen-md-min) {
  [slider-timer] { .p(0,35);
    li { .p(8,5,10);
      s { .fs(14); .calibre; .medium; color:#fff; opacity: 0.4; }
      .bar { .mt(5); }
      &.on {
        s { color: #fff; opacity: 1; }
      }
      .no-touch &:hover {
        s { color: #fff; opacity: 1; }
        .over { width: 100%; }
      }
    }
  }
}

@media (min-width: @screen-lg-min) {
  [slider-timer] { .p(0, 53);
    li { .p(8,7,10);
      s { .fs(18); }
      .bar { .mt(5); }
      &.on {
        s { color: #fff; opacity: 1; }
      }
    }
  }
}

@media (min-width: @screen-xl-min) {
  [slider-timer] { .p(0, 73);

  }
}
</style>
